
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAllCarImagesFolders, selectDealerMyCarPark, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { DomSanitizer } from '@angular/platform-browser';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarEditDialogComponent } from 'src/app/public/car/elements/car-edit/car-edit.component';
import { Car } from 'src/app/public/car/models/car.model';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { CarCriteria } from 'src/app/public/car/models/car-criteria.model';
import { TransactionRole, TransactionStage } from 'src/app/public/common/constants/common-basic-data';
import { CarStatus } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-owner-park',
    templateUrl: './owner-park.component.html',
    styleUrls: ['./owner-park.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OwnerParkComponent implements OnInit {
  
  sessionInfo = "Click to update data";
  
  progressInfos: any[] = [];
  message: string[] = [];

  myCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  currentSeller$: Observable<Dealer>;
  currentSeller: Dealer = new Dealer();

  transactionStages: TransactionStage[]= [TransactionStage.ONGOING];
  transactionRole: TransactionRole = TransactionRole.CUSTOMER
  TransactionStage = TransactionStage

  pageSize: number = 12;
  pageNumber: number = 1;

  constructor(
    private store: Store, 
    private router: Router, 
    private route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {
      
      this.myCars$ = store.select(selectDealerMyCarPark);
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.currentSeller$ = store.select(selectDealerProfile);
      
      this.currentSeller$.subscribe(
        (seller: Dealer) => {
          this.currentSeller = seller;
        }  
      ); 
    }
  
  ngOnInit(): void {

      //this.store.dispatch(DealerActions.fetchOwnerParkSubmit());  

      //let crt = JSON.parse(JSON.stringify(this.carCriteria));
      
console.log('heyyy')
      this.route.data.subscribe(
          data => {
console.log('heyyy 33')
            let crt = new CarCriteria();
            crt.pageSize = this.pageSize;
            crt.pageNumber = this.pageNumber;
            crt.statuses = []
            
            this.transactionStages = data['transactionStages'];

            

            if (this.transactionStages.includes(TransactionStage.PENDING)){

              crt.statuses.push(CarStatus.POSTING_TO_PROCESS)
            }

            if (this.transactionStages.includes(TransactionStage.COMPLETED)){

              crt.statuses.push(CarStatus.POSTING_PROCESSED)
            }

            if (this.transactionStages.includes(TransactionStage.CONFIRMED)){

              crt.statuses.push(CarStatus.DRAFT, CarStatus.LISTED, CarStatus.UNLISTED, CarStatus.CANCELLED)
            }

            //console.log("heyyy "+this.transactionStages)
            //console.log("heyyy 2 "+crt.statuses)

            this.store.dispatch(DealerActions.fetchOwnerParkSubmit( { carCriteria: crt } )); 

            //this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.transactionStages}));
          }
        )
      
    }
    
  uploadImage(carId: string, event: any, ): void {
    this.message = [];
    this.progressInfos = [];
    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
    
    
  }

  openCarEditDialog(): void {

    let car: Car = new Car();
    car.country = this.currentSeller.countryResident
    car.city = this.currentSeller.cityResident;
    

    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      data: car
    });

    dialogRef.afterClosed().subscribe((result: Car) => {

      //console.log(" result  = "+JSON.stringify(result));
      
      if(result != undefined ){
        //console.log(result)
        
        if(result.carId === ''){
          
          //result.buyPriceHistory.push(result.buyPrice);
          //result.rentPriceHistory.push(result.rentPrice);
          console.log(result);
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  } 
}
